import * as React from 'react';
import type { SVGProps } from 'react';

export const SvgBarChart = (props: SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    style={{
      color: 'inherit',
      ...props.style,
    }}
  >
    <path d="M12 13.3333V6.66663" stroke="currentColor"/>
    <path d="M8 13.3333V2.66663" stroke="currentColor" />
    <path d="M4 13.3334V9.33337" stroke="currentColor" />
  </svg>
);
